// Open the user's native maps app for a place lookup or driving directions.
//   - iPhone/iPad → Apple Maps via https://maps.apple.com/...
//   - Android     → Google Maps via https://www.google.com/maps/... (intercepted by the Google Maps app when installed)
//   - Other       → Google Maps in the browser

function platform() {
  if (typeof navigator === 'undefined') return 'other';
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/.test(ua)) return 'ios';
  if (/Android/.test(ua)) return 'android';
  return 'other';
}

export function openPlace(query) {
  const p = platform();
  const q = encodeURIComponent(query);
  const url =
    p === 'ios'
      ? `https://maps.apple.com/?q=${q}`
      : `https://www.google.com/maps/search/?api=1&query=${q}`;
  window.open(url, '_blank', 'noopener,noreferrer');
}

export function openDirections(from, to) {
  const p = platform();
  const f = encodeURIComponent(from);
  const t = encodeURIComponent(to);
  const url =
    p === 'ios'
      ? `https://maps.apple.com/?saddr=${f}&daddr=${t}&dirflg=d`
      : `https://www.google.com/maps/dir/?api=1&origin=${f}&destination=${t}&travelmode=driving`;
  window.open(url, '_blank', 'noopener,noreferrer');
}
